import React, { Component } from "react";

import { Input, message } from 'antd';
import WidgetAjax from "../../widget/WidgetAjax";
import Config from "../../config/Config";
import './../../css/frame.css';
import './../../css/project.css';
import './index.scss';

class Query extends Component {

    constructor(props) 
    {
        super(props);

        this.state = {
            ENTNAME:'',
            UNISCID:''
        }
    }

    onChange(value) {
        console.log(value);
    };
    goPage(){
        window.history.back(-1)
    };
    queryCheckEntType(){
        if(!this.state.UNISCID){
            message.warning('统一社会信用代码');
            return
        }
        WidgetAjax.ajax({
            url : Config.getBasePath()+'/businessSystem/checkEntType', 
            params : {
                ENTNAME: this.state.ENTNAME,
                UNISCID: this.state.UNISCID
            }, 
            callback : (data)=>{
                if(data&&data.status === 0){
                   localStorage.setItem("ENTTYPE",data.result.ENTTYPE)
                    window.history.back(-1)
                }
            }
        },this);
    }
    render()
    {
        let { ENTNAME, UNISCID } = this.state
        return (
            <div data-component="query">
                <div className="sg-query">
                    <div className="sg-query-list sd-spaceBetween">
                        <div className="sg-list-left">个体工商户名称</div>
                        <Input placeholder="请输入" className="sg-list-right" bordered={false} value={ENTNAME} onChange={(e)=>this.setState({ENTNAME:e.target.value})}/>
                    </div>
                    <div className="sg-query-list sd-spaceBetween">
                        <div className="sg-list-left"><span className="sg-left-color1">*</span>统一社会信用代码</div>
                        <Input placeholder="请输入" className="sg-list-right" bordered={false} value={UNISCID} onChange={(e)=>this.setState({UNISCID:e.target.value})}/>
                    </div>
                    <div className="sg-query-btn sd-end">
                        <div className="sg-btn-btn" onClick={()=>{this.queryCheckEntType()}}>查询</div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Query
